<template lang="pug">
	div
		block-header
		.cookie
			.cookie__text(v-html="settings.cookies_page_content")
		block-footer
</template>

<script>

	import BlockHeader from '@/blocks/includes/header.vue';
	import BlockFooter from '@/blocks/includes/footer.vue';

	import AOS from 'aos';

	import {mapState} from 'vuex';

	export default {
		name: 'Cookie',
		metaInfo: function() {
			return {
				title: 'Cookie Policy',
			}
		},
		computed: {
			...mapState([
				'settings'
			])
		},
		mounted() {
			this.$nextTick(() => {
				AOS.init({
					once: true,
					disabled: 'mobile',
					duration: 1000
				});
			})
		},
		components: {
			'block-header': BlockHeader,
			'block-footer': BlockFooter,
		}
	}

</script>

<style lang="scss" scoped>

	@import '@/helpers/sass/kit.scss';

	.cookie {
		max-width: 630px;
		margin: auto;
		margin-top: 128px;
		margin-bottom: 100px;

		&__text {
			margin-top: 37px;
			letter-spacing: .7px;
			font: 300 14px/18px 'Helvetica', Arial, sans-serif;

      p {
        line-height: 1.24;
      }
		}

    >>> h1 {
			font: 700 42px/1.2 'Helvetica', Arial, sans-serif;
			color: #333333;
			letter-spacing: 2px;
		}

    >>> h3 {
			font-weight: 500;
			font-size: 14px;
			margin: 12px 0;
		}

    >>> h2 {
			font-weight: 500;
			font-size: 18px;
			margin: 18px 0;
			letter-spacing: 1px;
		}

    >>> a {
			text-decoration: underline;
			transition: opacity .5s ease;

			@media screen and (min-width: 1200px) {
				&:hover {
					opacity: .7;
				}
			}
		}

    >>> ol {
			font: 300 14px/18px 'Helvetica', Arial, sans-serif;
			margin-bottom: 15px;
		}

    >>> ul {
			font: 300 14px/18px 'Helvetica', Arial, sans-serif;
			margin-bottom: 15px;

			li {
				&:before {
					content: "";
					display: inline-block;
					width: 12px;
					height: 12px;
					border-radius: 50%;
					background-color: #333333;
					margin-right: 5px;
					position: relative;
					top: 1px;
				}
			}
		}

    >>> li {
			font: 300 14px/18px 'Helvetica', Arial, sans-serif;
			margin: 10px 0;
		}
	}

	@media screen and (max-width: 1200px) {
		.cookie {
			padding: 0 20px;
			max-width: 100%;
			width: 100%;
			margin-top: 80px;

			&__title {
				font-size: 40px;
				text-align: center;
			}
		}
	}

</style>
